export const toAmount = (value: unknown): number => {
    if (value === null || value === undefined || value === "") {
        return 0;
    }

    const amount = Number(value);
    return Number.isFinite(amount) ? amount : 0;
};

export const emptySummary = {
    totalCount: 0,
    totalAmount: 0,
};
